export const heroImage =
  "https://readdy.ai/api/search-image?query=Stylized%20artistic%20portrait%20photography%20backdrop%2C%20soft%20peach%20and%20warm%20cream%20gradient%20with%20flowing%20silk%20fabric%20texture%2C%20elegant%20minimal%20editorial%20mood%2C%20dramatic%20side%20lighting%2C%20fine%20art%20photography%20aesthetic%2C%20high%20detail%2C%20harmonious%20warm%20tones&width=1920&height=1080&seq=xmt-hero-01&orientation=landscape";

export const statItems = [
  { id: "s1", value: "2,480+", label: "收录写真作品", icon: "ri-image-2-line" },
  { id: "s2", value: "186", label: "高清套图合集", icon: "ri-stack-line" },
  { id: "s3", value: "920+", label: "精选视频资源", icon: "ri-play-circle-line" },
  { id: "s4", value: "每日", label: "资源更新同步", icon: "ri-refresh-line" },
];

export const tickerItems = [
  "「午后街拍」系列新增 128P 高清套图，已同步至套图大全",
  "夏日海边 Vlog 4K 修复版上线，观赏体验更顺畅",
  "私拍福利专题更新 6 组精选美图，支持在线收藏",
  "小蜜桃写真 · 城市夜景篇章完成补档，共 96P",
  "本周热门视频 TOP10 榜单已刷新，欢迎查看",
  "复古胶片专题合辑上新，收录 3 组人气套图",
];

export const categories = [
  { id: "c1", name: "高清套图", desc: "成套收录 · 分类清晰", icon: "ri-gallery-line", count: "186 套" },
  { id: "c2", name: "视频资源", desc: "在线观赏 · 顺畅播放", icon: "ri-movie-2-line", count: "920+ 部" },
  { id: "c3", name: "私拍福利", desc: "限时专题 · 独家视角", icon: "ri-heart-3-line", count: "42 期" },
  { id: "c4", name: "美图精选", desc: "每日更新 · 随手收藏", icon: "ri-image-line", count: "1.2 万+ 张" },
  { id: "c5", name: "写真合集", desc: "按季节/风格整理", icon: "ri-book-open-line", count: "68 组" },
  { id: "c6", name: "资源导航", desc: "快速定位所需内容", icon: "ri-compass-3-line", count: "全站索引" },
];

export const timelineFeed = [
  {
    id: "t1",
    tag: "套图更新",
    time: "10 分钟前",
    title: "「午后街拍」128P 高清套图补档完成",
    desc: "本次更新补充了街角咖啡馆与巷弄光影两组场景，画质统一为 4K 原图，收藏后可随时回看。",
    hot: true,
  },
  {
    id: "t2",
    tag: "视频上新",
    time: "1 小时前",
    title: "夏日海边 Vlog 4K 修复版正式上线",
    desc: "重新调色并优化播放码率，移动端观赏更顺畅，支持倍速与画质切换。",
    hot: true,
  },
  {
    id: "t3",
    tag: "福利专题",
    time: "3 小时前",
    title: "私拍福利专题本期限时开放 6 组美图",
    desc: "以自然光人像为核心，突出真实的情绪与氛围，本期专题持续 7 天。",
    hot: false,
  },
  {
    id: "t4",
    tag: "合集整理",
    time: "今天 09:20",
    title: "复古胶片合辑重新整理，按拍摄年份归档",
    desc: "把散落的 3 组人气套图统一入口，方便按风格与年份快速检索。",
    hot: false,
  },
  {
    id: "t5",
    tag: "榜单刷新",
    time: "昨天 21:05",
    title: "本周热门视频 TOP10 榜单已刷新",
    desc: "根据近七天观赏与收藏数据综合排序，帮你快速找到当下最受关注的内容。",
    hot: false,
  },
  {
    id: "t6",
    tag: "资源维护",
    time: "昨天 15:40",
    title: "完成全站图片资源本地化与失效链接修复",
    desc: "本轮维护清理了 200+ 失效入口，观赏与下载入口的到达率进一步提升。",
    hot: false,
  },
];

export const galleryItems = [
  {
    id: "g1",
    title: "午后街拍 · 光影漫步",
    meta: "128P · 4K 原图",
    tag: "街拍",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20soft%20peach%20toned%20portrait%20cover%20art%2C%20elegant%20young%20woman%20silhouette%20in%20morning%20light%2C%20minimal%20warm%20cream%20background%2C%20fine%20art%20editorial%20photography%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=1000&seq=xmt-g01&orientation=portrait",
  },
  {
    id: "g2",
    title: "夏日海边 · 微风轻拂",
    meta: "96P · 4K 原图",
    tag: "海边",
    cover:
      "https://readdy.ai/api/search-image?query=Dreamy%20seaside%20portrait%20cover%20art%20with%20soft%20sand%20and%20peach%20sky%2C%20flowing%20fabric%20in%20breeze%2C%20minimal%20warm%20tone%2C%20fine%20art%20editorial%20photography%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=1000&seq=xmt-g02&orientation=portrait",
  },
  {
    id: "g3",
    title: "咖啡馆午后 · 慢时光",
    meta: "72P · 高清",
    tag: "生活",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20cafe%20afternoon%20portrait%20cover%20art%2C%20warm%20cream%20and%20caramel%20tones%2C%20soft%20window%20light%2C%20minimal%20elegant%20mood%2C%20fine%20art%20editorial%20photography%20aesthetic%2C%20high%20detail&width=800&height=1000&seq=xmt-g03&orientation=portrait",
  },
  {
    id: "g4",
    title: "樱花季节 · 粉色记忆",
    meta: "110P · 4K 原图",
    tag: "写真",
    cover:
      "https://readdy.ai/api/search-image?query=Spring%20sakura%20portrait%20cover%20art%20with%20soft%20pink%20blossoms%20bokeh%2C%20warm%20pastel%20palette%2C%20minimal%20romantic%20mood%2C%20fine%20art%20editorial%20photography%20aesthetic%2C%20high%20detail&width=800&height=1000&seq=xmt-g04&orientation=portrait",
  },
  {
    id: "g5",
    title: "城市夜景 · 霓虹倒影",
    meta: "84P · 高清",
    tag: "夜景",
    cover:
      "https://readdy.ai/api/search-image?query=Urban%20night%20portrait%20cover%20art%20with%20warm%20amber%20bokeh%20lights%2C%20rain%20reflections%20on%20street%2C%20cinematic%20mood%2C%20fine%20art%20editorial%20photography%20aesthetic%2C%20high%20detail&width=800&height=1000&seq=xmt-g05&orientation=portrait",
  },
  {
    id: "g6",
    title: "复古胶片 · 旧日滤镜",
    meta: "60P · 胶片扫图",
    tag: "胶片",
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20film%20portrait%20cover%20art%20with%20grainy%20analog%20texture%2C%20muted%20terracotta%20and%20cream%20tones%2C%20nostalgic%20mood%2C%20fine%20art%20editorial%20photography%20aesthetic%2C%20high%20detail&width=800&height=1000&seq=xmt-g06&orientation=portrait",
  },
  {
    id: "g7",
    title: "秋日落叶 · 温柔告白",
    meta: "92P · 4K 原图",
    tag: "季节",
    cover:
      "https://readdy.ai/api/search-image?query=Autumn%20portrait%20cover%20art%20with%20warm%20amber%20leaves%20and%20soft%20golden%20light%2C%20cozy%20cream%20palette%2C%20minimal%20elegant%20mood%2C%20fine%20art%20editorial%20photography%20aesthetic%2C%20high%20detail&width=800&height=1000&seq=xmt-g07&orientation=portrait",
  },
  {
    id: "g8",
    title: "冬日暖阳 · 室内光影",
    meta: "76P · 高清",
    tag: "室内",
    cover:
      "https://readdy.ai/api/search-image?query=Winter%20indoor%20portrait%20cover%20art%20with%20soft%20window%20sunlight%20and%20cozy%20neutral%20textiles%2C%20warm%20cream%20tones%2C%20minimal%20elegant%20mood%2C%20fine%20art%20editorial%20photography%20aesthetic&width=800&height=1000&seq=xmt-g08&orientation=portrait",
  },
  {
    id: "g9",
    title: "清新氧气 · 自然写真",
    meta: "104P · 4K 原图",
    tag: "清新",
    cover:
      "https://readdy.ai/api/search-image?query=Fresh%20natural%20portrait%20cover%20art%20with%20soft%20green%20foliage%20and%20peach%20highlights%2C%20airy%20minimal%20mood%2C%20fine%20art%20editorial%20photography%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=1000&seq=xmt-g09&orientation=portrait",
  },
];

export const videoItems = [
  {
    id: "v1",
    title: "小蜜桃视频 · 夏日海边 Vlog",
    duration: "12:36",
    views: "8.6 万",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20seaside%20scene%20thumbnail%2C%20warm%20peach%20sunset%20over%20calm%20ocean%2C%20soft%20waves%2C%20minimal%20elegant%20film%20still%2C%20fine%20art%20photography%20aesthetic%2C%20high%20detail&width=640&height=360&seq=xmt-v01&orientation=landscape",
  },
  {
    id: "v2",
    title: "小蜜桃视频 · 城市漫游纪实",
    duration: "09:18",
    views: "6.2 万",
    quality: "1080P",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20city%20stroll%20thumbnail%2C%20warm%20amber%20evening%20streets%2C%20soft%20bokeh%20lights%2C%20minimal%20elegant%20film%20still%2C%20fine%20art%20photography%20aesthetic%2C%20high%20detail&width=640&height=360&seq=xmt-v02&orientation=landscape",
  },
  {
    id: "v3",
    title: "小蜜桃视频 · 胶片质感合集",
    duration: "15:02",
    views: "11.4 万",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=Analog%20film%20grain%20cinematic%20thumbnail%2C%20muted%20terracotta%20and%20cream%20tones%2C%20soft%20light%20leak%2C%20minimal%20elegant%20film%20still%2C%20fine%20art%20photography%20aesthetic&width=640&height=360&seq=xmt-v03&orientation=landscape",
  },
  {
    id: "v4",
    title: "小蜜桃视频 · 室内光影日常",
    duration: "07:45",
    views: "4.9 万",
    quality: "1080P",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20indoor%20soft%20light%20cinematic%20thumbnail%2C%20warm%20cream%20and%20peach%20tones%2C%20minimal%20elegant%20film%20still%2C%20fine%20art%20photography%20aesthetic%2C%20high%20detail&width=640&height=360&seq=xmt-v04&orientation=landscape",
  },
];

export const faqItems = [
  {
    id: "f1",
    q: "美丽的小蜜桃的写真与视频资源多久更新一次？",
    a: "常规套图基本保持每日更新，视频资源按拍摄节奏每周 2 至 3 次上新。你可以关注首页「最新更新」时间线，第一时间看到新增的套图、视频与福利专题。",
  },
  {
    id: "f2",
    q: "怎样快速找到想要的套图或视频资源？",
    a: "可以通过顶部的分类速览进入「高清套图」「视频资源」「私拍福利」等板块，也可以在资源导航里按季节、风格、年份筛选，帮助你在数百组内容中快速定位。",
  },
  {
    id: "f3",
    q: "收藏的内容会保留多久，会不会失效？",
    a: "收藏入口会长期保留，站内也会定期进行资源维护，清理失效链接并重新整理归档。如果发现入口异常，欢迎通过订阅通道反馈，我们会尽快修复。",
  },
  {
    id: "f4",
    q: "资源是高清原图吗，观赏体验怎么样？",
    a: "套图以 4K 原图为主，视频提供 1080P 与 4K 两档清晰度并支持在线观赏与倍速播放，移动端与桌面端都已针对顺畅体验做过优化。",
  },
  {
    id: "f5",
    q: "订阅后能获得什么？",
    a: "订阅更新提醒后，可以在新增套图、视频与福利专题上线时第一时间收到通知。我们只推送与资源更新相关的信息，不会打扰你的日常节奏。",
  },
];

export const footerLinks = [
  {
    title: "内容板块",
    links: ["高清套图", "视频资源", "私拍福利", "美图精选", "写真合集"],
  },
  {
    title: "关于站点",
    links: ["站点介绍", "更新说明", "资源维护", "收藏指南", "常见问题"],
  },
  {
    title: "帮助与反馈",
    links: ["订阅更新", "入口失效反馈", "内容建议", "合作说明"],
  },
];